import { Component, OnInit, ElementRef } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AuthService } from 'app/service/auth/auth.service';
import { Subscription } from 'rxjs';
import decode from 'jwt-decode';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    private toggleButton: any;
    private sidebarVisible: boolean;
    public userName: any;
    public userLoginSubscription: Subscription;

    constructor(
        public location: Location,
        private element: ElementRef,
        public authService: AuthService) {
        this.sidebarVisible = false;
    }

    async ngOnInit() {
        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        this.refreshUserProfile();
        this.userLoginSubscription = this.authService.userProfileSubject.subscribe(async (data: any) => {
            if (data.type === 'userLogged') {
                const decodeToken: any = decode(data.response)
                const userProfile = await this.authService.getUserProfile(decodeToken.sub).toPromise();
                this.userName = userProfile.msg.name;
            }
        });
    } // fin ngOnInit

    async refreshUserProfile() {
        const token = localStorage.getItem('access_token');
        if (token !== null) {
            const decodeToken: any = decode(token);
            const userProfile = await this.authService.getUserProfile(decodeToken.sub).toPromise();
            this.userName = userProfile.msg.name;
        }
    } // fin refreshUserProfile

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const html = document.getElementsByTagName('html')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        html.classList.add('nav-open');

        this.sidebarVisible = true;
    };
    sidebarClose() {
        const html = document.getElementsByTagName('html')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        html.classList.remove('nav-open');
    };
    sidebarToggle() {
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };
    isSignuporin() {
        let titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        } else {
        }
        if ((titlee === '/signin') || (titlee === '/signup')) {
            return true;
        } else {
            return false;
        }
    }

    logout() {
        this.authService.doLogout();
    }
}
